import React from 'react';
import { Divider } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import { defaultMenuLinks } from '../../constants/menuLinks.js';
import { defaultSocialLinks } from '../../constants/socialLinks.js';
import { defaultSupport } from '../../constants/support.js';
import { Bottom } from '../Bottom/Bottom.js';
import { MobileApp } from '../MobileApp/MobileApp.js';
import { Socials } from '../Socials/Socials.js';
import modules_2529eb59 from './Footer.module.less.js';

/**
 * @description Footer component.
 *
 * @component
 * @example
 * ```jsx
 * <Footer />
 * ```
 */
const Footer = React.forwardRef((props, ref) => {
    const { links: deprecatedMenuLinks, menuLinks: outsideMenuLinks, socialLinks: outsideSocialLinks, mode = 'default', support: outsideSupport, className = '', ...restProps } = props;
    const cx = useStyles(modules_2529eb59);
    const support = React.useMemo(() => ({
        ...defaultSupport,
        ...outsideSupport,
        channels: typeof outsideSupport?.channels !== 'undefined' ? outsideSupport.channels : defaultSupport.channels,
    }), [outsideSupport]);
    const socialLinks = React.useMemo(() => outsideSocialLinks || defaultSocialLinks, [outsideSocialLinks]);
    const menuLinks = React.useMemo(() => {
        if (deprecatedMenuLinks)
            return deprecatedMenuLinks;
        if (outsideMenuLinks)
            return outsideMenuLinks;
        return defaultMenuLinks;
    }, [outsideMenuLinks, deprecatedMenuLinks]);
    const [showSocials, showMobileApp] = React.useMemo(() => {
        switch (mode) {
            case 'landing': {
                return [true, false];
            }
            default: {
                return [true, true];
            }
        }
    }, [mode]);
    return (React.createElement("footer", { ref: ref, "data-qa": "Footer", className: cx('container', className), ...restProps },
        React.createElement(Divider, null),
        showSocials && React.createElement(Socials, { socialLinks: socialLinks }),
        showMobileApp && React.createElement(MobileApp, null),
        React.createElement(Bottom, { menuLinks: menuLinks, mode: mode, support: support })));
});
Footer.displayName = 'Footer';

export { Footer };
//# sourceMappingURL=Footer.js.map
